<template>
  <div class="qc-item" :class="{ 'is-active': item.result === undefined }">
    <!-- 标题标签 -->
    <div class="qc-item__label" :class="{ 'is-active': item.result === undefined }">
      <span v-if="checkTarget === 'ORDER'">{{ orderMark }}</span>
      <span v-else-if="checkTarget === 'ROUTE'">行程</span>
    </div>

    <!-- 主内容区 -->
    <div class="qc-item__content">
      <!-- 选项组 -->
      <div class="qc-item__options">
        <el-radio-group v-model="result" @change="onCheck" :disabled="item.result !== undefined" size="small"
          class="qc-radio-group">
          <el-radio-button v-for="option in checkOptions" :key="option.value" :label="option.value"
            class="qc-radio-button">
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <!-- 操作区 -->
      <div class="qc-item__actions">
        <el-popover v-model="remarkVisible" placement="bottom-start" trigger="manual" width="260"
          popper-class="qc-popover">
          <div class="qc-popover__content">
            <el-input type="textarea" v-model="remarkText" :rows="3" maxlength="200" show-word-limit
              placeholder="填写备注（最多200字）" />
            <div class="qc-popover__footer">
              <el-button size="small" @click="remarkVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="confirmRemark">确定</el-button>
            </div>
          </div>
          <el-button slot="reference" type="text" size="small" @click="openRemark('remark')" class="qc-action-btn"
            :class="{ 'has-content': item.remark }">
            {{ item.remark ? "已备注" : "添加备注" }}
          </el-button>
          <el-button slot="reference" type="text" size="small" @click="openRemark('notice')" class="qc-action-btn"
            :class="{ 'has-content': item.noticeMsg }">
            {{ item.noticeMsg ? "已通知" : "通知" }}
          </el-button>
        </el-popover>

        <el-popover v-model="resourceVisible" placement="bottom-start" trigger="manual" width="320"
          popper-class="qc-popover">
          <div class="qc-popover__content">
            <el-select v-model="selectedResourceIds" filterable clearable multiple :loading="resourceLoading"
              placeholder="选择关联资源" size="small" style="width: 100%">
              <el-option v-for="rc in resourceList" :key="rc.id || rc.value || rc.url" :label="buildLabel(rc)"
                :value="rc.id || rc.value || rc.url" />
            </el-select>
            <div class="qc-popover__footer">
              <el-button size="small" @click="resourceVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="confirmResource">确定</el-button>
            </div>
          </div>
          <el-button slot="reference" type="text" size="small" @click="openResource"
            :disabled="item.result !== undefined" class="qc-action-btn"
            :class="{ 'has-content': selectedResourceLabels.length > 0 }">
            关联佐证
          </el-button>
        </el-popover>

        <!-- 关联资源标签 -->
        <!-- <div class="qc-item__tags" v-if="selectedResourceLabels.length > 0">
          <el-tag
            v-for="label in selectedResourceLabels"
            :key="label"
            size="mini"
            closable
            @close="removeResource(label)"
            class="qc-tag"
          >
            {{ label }}
          </el-tag>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { DateUtil } from "@/util";
import Vue from "vue";
export default {
  name: "RouteQcItem",
  props: {
    item: { type: Object, required: true },
    routeInfo: { type: Object, default: () => ({}) },
    orderMap: { type: Object, default: () => ({}) },
    checkTarget: { type: String, default: "ORDER" },
    resourceList: { type: Array, default: () => [] }
  },
  data() {
    return {
      checkOptions: [
        { label: "未检查", value: 3 },
        { label: "合格", value: 1 },
        { label: "不合格", value: 0 },
        { label: "待改进", value: 2 }
      ],
      remarkVisible: false,
      remarkText: "",
      resourceVisible: false,
      resourceLoading: false,
      selectedResourceIds: [],
      result: undefined,
      remarkType: "remark"
    };
  },
  filters: {},
  watch: {
    item: {
      handler(newVal) {
        // 当item prop更新时，同步备注和资源ID
        if (newVal) {
          this.remarkText = newVal.remark || "";
          this.selectedResourceIds = newVal.resourceIds || [];
          this.result = newVal.result;
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    orderMark() {
      if (this.item && this.item.orderId) {
        const order = this.orderMap[this.item.orderId];
        return `【${order.orderIndex + 1}号单-${order.telephone.substr(7)}】`;
      }
      return "";
    },
    selectedResourceLabels() {
      return (
        this.item.resourceIds?.map((id) => {
          const found = this.resourceList.find((rc) => rc.id === id);
          return found ? this.buildLabel(found) : "";
        }) || []
      );
    }
  },
  methods: {
    onCheck(result) {
      this.$emit("check", result);
    },
    openRemark(type) {
      this.remarkType = type;
      if (type === "remark") {
        this.remarkText = this.item.remark || "";
      } else if (type === "notice") {
        const noticeMsg = this.item.noticeMsg || "";
        this.remarkText = noticeMsg.trim() ? noticeMsg : this.buildDefaultNoticeText();
      }
      this.remarkVisible = !this.remarkVisible;
    },
    buildDefaultNoticeText() {
      if (this.routeInfo) {
        const pathFilter = Vue.options.filters["pathNameTransfer"];
        const { date, pathId, showTime } = this.routeInfo;
        const dateText = DateUtil.dateStrFormat(date, "MM月dd日");
        const pathName = pathFilter(pathId);
        const segments = [dateText, pathName, showTime].filter((text) => !!text);
        if (!segments.length) {
          return "";
        }

        const prefix = `您在 ${segments.join(" ")} 的行程中，`;
        return `${prefix}${this.buildNoticeSuffixForItem(this.item.item)}`;
      }
      return "";
    },

    /**
     * 通知默认文案中，前缀统一为「您在 {日期 路线 时间} 的行程中，」后的后缀。
     * 按质检项 item.item 配置；未配置的项返回空字符串（仅保留前缀便于手动补充）。
     */
    buildNoticeSuffixForItem(itemCode) {
      const suffixByItem = {
        6: '平台旨在为乘客提供高效、优质的出行服务，因此对在服务区的休息与补给时间有着明确规定，即不得超过15分钟。此次经核实，您在{{serviceAreaName}}服务区停留了{{minutes}}分钟。本次先对您作出提醒，希望您在今后的行程中，合理安排在服务区的时间，严格遵守平台规定。相信您在充分了解规定后，一定能更好地把控时间，为乘客带来更优质的服务体验。',
        11: "核实到您本次行程未按平台规划行走导致高速过路费超出平台规划范围，但核实此次为您本月首次此类违规，平台人性化管理此次超出范围由平台承担，后续如再次有此违规，超出部分将由您本人承担！",
        21: "根据现行交通法规，乘车时所有人员都必须系好安全带，这是保障生命安全的重要举措。作为网约车司机，您肩负着提醒乘客系好安全带的责任。希望您始终将安全意识贯穿于每一次行程，严格履行提醒乘客系安全带的职责。让我们共同努力，为每一位乘客的出行安全保驾护航。",
        22:
          "与乘客首次电话约上车时间，必须按照规划时间点前后10分钟时间段约上车时间示例：……您好！我是城小班司机……我会在……的前后10分钟的时间段内来接您",
        23: "刻意拨打挂机电话，不及时联系乘客"
      };
      return suffixByItem[itemCode] != null ? suffixByItem[itemCode] : "";
    },

    confirmRemark() {
      this.remarkVisible = false;
      // 更新item的remark字段，并通知父组件
      if (this.remarkType === "remark") {
        const updatedItem = { ...this.item, remark: this.remarkText };
        this.$emit("update", updatedItem);
      } else if (this.remarkType === "notice") {
        const updatedItem = { ...this.item, noticeMsg: this.remarkText };
        this.$emit("update", updatedItem);
      }
    },
    openResource() {
      this.resourceVisible = !this.resourceVisible;
    },
    confirmResource() {
      this.resourceVisible = false;
      // 更新item的resourceIds字段，并通知父组件
      const updatedItem = { ...this.item, resourceIds: this.selectedResourceIds };
      this.$emit("update", updatedItem);
    },
    removeResource(label) {
      // 根据label找到对应的id并移除
      const found = this.resourceList.find((rc) => this.buildLabel(rc) === label);
      if (found) {
        const id = found.id || found.value || found.url;
        const newIds = (this.item.resourceIds || []).filter((itemId) => itemId !== id);
        const updatedItem = { ...this.item, resourceIds: newIds };
        this.$emit("update", updatedItem);
      }
    },
    buildLabel(rc) {
      return rc.remark || rc.name || rc.fileName;
    }
  }
};
</script>

<style lang="less" scoped>
.qc-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px 12px;
  margin-bottom: 8px;
  margin-right: 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  &.is-active {
    border-color: #409eff;
    background: #f0f9ff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  }

  // 标题标签
  .qc-item__label {
    flex-shrink: 0;
    padding: 4px 10px;
    background: linear-gradient(135deg, #b3c6f5 0%, #d2b7e6 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    border-radius: 12px;
    white-space: nowrap;
    line-height: 1.4;
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);

    &.is-active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
  }

  // 主内容区
  .qc-item__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
  }

  // 选项组
  .qc-item__options {
    .qc-radio-group {
      display: flex;
      width: 100%;

      /deep/ .el-radio-button {
        flex: 1;
        margin-right: 0;

        &:not(:last-child) {
          margin-right: 4px;
        }

        .el-radio-button__inner {
          padding: 6px 12px;
          font-size: 12px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          background: #fff;
          color: #606266;
          transition: all 0.2s;

          &:hover {
            color: #409eff;
            border-color: #409eff;
          }
        }

        &.is-active .el-radio-button__inner {
          background: #409eff;
          border-color: #409eff;
          color: #fff;
          box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
        }

        &.is-disabled .el-radio-button__inner {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      /deep/ .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 4px;
      }

      /deep/ .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 4px;
      }
    }
  }

  // 操作区
  .qc-item__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    .qc-action-btn {
      padding: 4px 8px;
      font-size: 12px;
      color: #606266;
      border-radius: 4px;
      transition: all 0.2s;

      &:hover {
        color: #409eff;
        background: rgba(64, 158, 255, 0.1);
      }

      &.has-content {
        color: #409eff;
        font-weight: 500;

        &:hover {
          background: rgba(64, 158, 255, 0.15);
        }
      }
    }

    // 资源标签
    .qc-item__tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px;

      .qc-tag {
        margin: 0;
        border-radius: 12px;
        font-size: 11px;
        padding: 2px 8px;
        background: #f0f2f5;
        border-color: #e4e7ed;
        color: #606266;

        &:hover {
          background: #e4e7ed;
        }
      }
    }
  }
}

.qc-popover__footer {
  margin-top: 12px;
  text-align: right;
}
</style>
